<!-- SPDX-License-Identifier: GPL-3.0-or-later -->
<script lang="ts">
  import LobbyTemplate from '../templates/LobbyTemplate.svelte';
  import LobbyForm from '../organisms/LobbyForm.svelte';
  import { LobbyViewModel, type LobbyJoinPayload } from '$lib/viewmodels/LobbyViewModel.svelte';

  interface Props {
    onJoin: (payload: LobbyJoinPayload) => void;
  }

  let { onJoin }: Props = $props();

  // Оборачиваем в closure: Svelte 5 предупреждает, что иначе замыкаем начальное значение prop.
  const vm = new LobbyViewModel({ onJoin: (payload) => onJoin(payload) });
</script>

<LobbyTemplate>
  {#snippet form()}
    <LobbyForm
      bind:userName={vm.userName}
      bind:roomName={vm.roomName}
      error={vm.error ?? undefined}
      onUserNameChange={(v) => vm.setUserName(v)}
      onRoomNameChange={(v) => vm.setRoomName(v)}
      onJoin={() => vm.submit()}
    />
  {/snippet}
</LobbyTemplate>
